module.exports = __webpack_public_path__ + "static/media/Man.8e2409e9.png";